<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <div class="search-con search-con-top">
            <span style="margin-right: 8px;">日期范围：</span>
            <DatePicker
              v-model="dateRange"
              type="daterange"
              placement="bottom-end"
              placeholder="选择日期范围"
              style="width: 260px;"
              @on-change="handleDateChange"
            ></DatePicker>
            <Button type="primary" @click="searchinput" class="search-btn" style="margin-left: 8px;">查询</Button>
          </div>
          <Spin size="large" fix v-if="spinShow"></Spin>
        </Card>
      </i-col>
    </Row>

    <!-- Statistics Cards -->
    <Row :gutter="10" style="margin-bottom: 10px;">
      <i-col :md="4" :lg="4">
        <Card :padding="10" class="stat-card" @click.native="openCardDetail('visits')">
          <div style="text-align: center;">
            <p style="color: #808695; font-size: 14px;">访问总数</p>
            <h3 style="color: #2d8cf0; margin: 5px 0;">{{ statsData.total_visits || 0 }}</h3>
          </div>
        </Card>
      </i-col>
      <i-col :md="4" :lg="4">
        <Card :padding="10" class="stat-card" @click.native="openCardDetail('abnormal')">
          <div style="text-align: center;">
            <p style="color: #808695; font-size: 14px;">异常总数</p>
            <h3 style="color: #ed4014; margin: 5px 0;">{{ statsData.total_abnormal || 0 }}</h3>
          </div>
        </Card>
      </i-col>
      <i-col :md="4" :lg="4">
        <Card :padding="10" class="stat-card" @click.native="openCardDetail('ips')">
          <div style="text-align: center;">
            <p style="color: #808695; font-size: 14px;">IP总数</p>
            <h3 style="color: #19be6b; margin: 5px 0;">{{ statsData.total_ips || 0 }}</h3>
          </div>
        </Card>
      </i-col>
      <i-col :md="4" :lg="4">
        <Card :padding="10" class="stat-card" @click.native="openCardDetail('blacklist')">
          <div style="text-align: center;">
            <p style="color: #808695; font-size: 14px;">黑名单数</p>
            <h3 style="color: #ed4014; margin: 5px 0;">{{ statsData.blacklist_count || 0 }}</h3>
          </div>
        </Card>
      </i-col>
      <i-col :md="4" :lg="4">
        <Card :padding="10" class="stat-card" @click.native="openCardDetail('whitelist')">
          <div style="text-align: center;">
            <p style="color: #808695; font-size: 14px;">白名单数</p>
            <h3 style="color: #19be6b; margin: 5px 0;">{{ statsData.whitelist_count || 0 }}</h3>
          </div>
        </Card>
      </i-col>
      <i-col :md="4" :lg="4">
        <Card :padding="10" class="stat-card" @click.native="openCardDetail('wechat')">
          <div style="text-align: center;">
            <p style="color: #808695; font-size: 14px;">微信访问数</p>
            <h3 style="color: #ff9900; margin: 5px 0;">{{ statsData.wechat_visits || 0 }}</h3>
          </div>
        </Card>
      </i-col>
    </Row>

    <!-- Card Detail Modal -->
    <Modal v-model="cardModalVisible" :title="cardModalTitle" :footer-hide=true
           :mask-closable=false width="900">
      <Spin size="large" fix v-if="cardSpinShow"></Spin>
      <Table height="450" size="small" border
             :columns="cardColumns" :data="cardTableData"></Table>
      <div style="margin: 10px; overflow: hidden" v-if="cardPageTotal > 0">
        <div style="float: left;">
          <Page :total="cardPageTotal" :current="cardPageNum" :page-size="cardPageSize"
                :page-size-opts=[15,35,50,100] show-sizer show-total
                @on-change="changeCardPage" @on-page-size-change="handleCardPageSize">
          </Page>
        </div>
      </div>
    </Modal>

    <!-- Trend Chart -->
    <Row :gutter="10" style="margin-bottom: 10px;">
      <i-col :md="24" :lg="24">
        <Card>
          <p slot="title" style="font-size: 14px; font-weight: 600;">访问趋势</p>
          <Spin size="large" fix v-if="chartSpinShow"></Spin>
          <div ref="trendChart" style="height: 280px;"></div>
        </Card>
      </i-col>
    </Row>

    <!-- Tabs: Access Records & Abnormal Records -->
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <div style="margin-bottom: 10px; display: flex; justify-content: space-between; align-items: center;">
            <Tabs v-model="activeTab" @on-click="handleTabChange">
              <TabPane label="访问记录" name="access"></TabPane>
              <TabPane label="异常访问" name="abnormal"></TabPane>
            </Tabs>
            <Button type="primary" @click="openConfigModal">安全配置</Button>
          </div>

          <div class="search-con" style="margin-bottom: 10px;">
            <Input class="search-input" v-model="searchVal" style="padding:5px;" placeholder="输入IP搜索"
                   @on-enter="searchinput"/>
            <Input class="search-input" v-model="pathKey" style="padding:5px;" placeholder="输入路径模糊搜索"
                   @on-enter="searchinput" @on-clear="searchinput" clearable/>
            <Button type="primary" @click="searchinput" class="search-btn">搜索</Button>
          </div>

          <Spin size="large" fix v-if="tableSpinShow"></Spin>

          <Table v-if="activeTab === 'access'" v-loading.fullscreen.lock="fullscreenLoading" height="400" size="small" border
                 :columns="accessColumns" :data="tableData"></Table>

          <Table v-if="activeTab === 'abnormal'" v-loading.fullscreen.lock="fullscreenLoading" height="400" size="small" border
                 :columns="abnormalColumns" :data="tableData"></Table>

          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>
        </Card>
      </i-col>
    </Row>

    <!-- Security Config Modal -->
    <Modal v-model="configModalVisible" title="安全配置" :loading=true :footer-hide=true
           :mask-closable=false width="720">
      <Spin size="large" fix v-if="configSpinShow"></Spin>
      <Form ref="configForm" :model="configForm" :label-width="140">
        <FormItem v-for="(item, index) in configList" :key="item.id" :label="item.config_key">
          <Input v-model="configForm['val_' + item.id]" :placeholder="'请输入' + item.config_key"></Input>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleConfigSubmit" :loading="configSubmitting">保存配置</Button>
          <Button @click="configModalVisible = false" style="margin-left: 8px">取消</Button>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
import echarts from 'echarts'
import { getSecurityOverview } from '@/api/sys/security_overview.js'
import { getSecurityConfigList, operationSecurityConfig } from '@/api/sys/security_config.js'

export default {
  data() {
    return {
      spinShow: false,
      tableSpinShow: false,
      chartSpinShow: false,
      fullscreenLoading: false,
      dateRange: [],
      startDate: '',
      endDate: '',
      searchVal: '',
      pathKey: '',
      activeTab: 'access',
      statsData: {
        total_visits: 0,
        total_abnormal: 0,
        total_ips: 0,
        blacklist_count: 0,
        whitelist_count: 0,
        wechat_visits: 0
      },
      tableData: [],
      pageNum: 1,
      pageTotal: 0,
      pageSize: 15,
      trendChart: null,

      // Card detail modal
      cardModalVisible: false,
      cardModalTitle: '',
      cardSpinShow: false,
      cardDetailType: '',
      cardTableData: [],
      cardPageNum: 1,
      cardPageTotal: 0,
      cardPageSize: 15,

      accessColumns: [
        {
          title: '序号', key: '_index', width: 65, align: 'center',
          render: (h, params) => h('span', params.index + 1 + (this.pageNum - 1) * this.pageSize)
        },
        { title: 'IP', key: 'ip', align: 'center', minWidth: 140, tooltip: true },
        { title: '端口', key: 'source_port', align: 'center', width: 80 },
        { title: '方法', key: 'method', align: 'center', width: 80 },
        { title: '路径', key: 'path', align: 'center', minWidth: 180, tooltip: true },
        { title: '状态码', key: 'status_code', align: 'center', width: 80 },
        { title: '时间', key: 'create_time', align: 'center', minWidth: 160, tooltip: true }
      ],

      abnormalColumns: [
        {
          title: '序号', key: '_index', width: 65, align: 'center',
          render: (h, params) => h('span', params.index + 1 + (this.pageNum - 1) * this.pageSize)
        },
        { title: 'IP', key: 'ip', align: 'center', minWidth: 140, tooltip: true },
        { title: '原因', key: 'reason', align: 'center', minWidth: 150, tooltip: true },
        { title: '访问次数', key: 'access_count', align: 'center', width: 100 },
        { title: '时间窗口', key: 'time_window', align: 'center', minWidth: 120 },
        { title: '路径', key: 'path', align: 'center', minWidth: 180, tooltip: true },
        { title: '时间', key: 'create_time', align: 'center', minWidth: 160, tooltip: true }
      ],

      // Config Modal
      configModalVisible: false,
      configSpinShow: false,
      configSubmitting: false,
      configList: [],
      configForm: {}
    };
  },
  computed: {
    cardColumns() {
      if (this.cardDetailType === 'visits') {
        return [
          { title: '序号', key: '_index', width: 65, align: 'center',
            render: (h, params) => h('span', params.index + 1 + (this.cardPageNum - 1) * this.cardPageSize) },
          { title: 'IP', key: 'ip', align: 'center', minWidth: 140, tooltip: true },
          { title: '端口', key: 'source_port', align: 'center', width: 80 },
          { title: '方法', key: 'method', align: 'center', width: 80 },
          { title: '路径', key: 'path', align: 'center', minWidth: 180, tooltip: true },
          { title: '状态码', key: 'status_code', align: 'center', width: 80 },
          { title: '时间', key: 'create_time', align: 'center', minWidth: 160, tooltip: true }
        ];
      }
      if (this.cardDetailType === 'abnormal') {
        return [
          { title: '序号', key: '_index', width: 65, align: 'center',
            render: (h, params) => h('span', params.index + 1 + (this.cardPageNum - 1) * this.cardPageSize) },
          { title: 'IP', key: 'ip', align: 'center', minWidth: 140, tooltip: true },
          { title: '原因', key: 'reason', align: 'center', minWidth: 150, tooltip: true },
          { title: '访问次数', key: 'access_count', align: 'center', width: 100 },
          { title: '时间窗口', key: 'time_window', align: 'center', minWidth: 120 },
          { title: '路径', key: 'path', align: 'center', minWidth: 180, tooltip: true },
          { title: '时间', key: 'create_time', align: 'center', minWidth: 160, tooltip: true }
        ];
      }
      if (this.cardDetailType === 'ips') {
        return [
          { title: '序号', key: '_index', width: 65, align: 'center',
            render: (h, params) => h('span', params.index + 1) },
          { title: 'IP', key: 'ip', align: 'center', minWidth: 160, tooltip: true },
          { title: '访问次数', key: 'count', align: 'center', width: 120 },
          { title: '最后访问', key: 'last_time', align: 'center', minWidth: 160, tooltip: true }
        ];
      }
      if (this.cardDetailType === 'wechat') {
        return [
          { title: '序号', key: '_index', width: 65, align: 'center',
            render: (h, params) => h('span', params.index + 1 + (this.cardPageNum - 1) * this.cardPageSize) },
          { title: 'IP', key: 'ip', align: 'center', minWidth: 140, tooltip: true },
          { title: '端口', key: 'source_port', align: 'center', width: 80 },
          { title: '方法', key: 'method', align: 'center', width: 80 },
          { title: '路径', key: 'path', align: 'center', minWidth: 180, tooltip: true },
          { title: '状态码', key: 'status_code', align: 'center', width: 80 },
          { title: '时间', key: 'create_time', align: 'center', minWidth: 160, tooltip: true }
        ];
      }
      return [
        { title: '序号', key: '_index', width: 65, align: 'center',
          render: (h, params) => h('span', params.index + 1) },
        { title: 'IP', key: 'ip', align: 'center', minWidth: 160, tooltip: true },
        { title: '类型', key: 'type', align: 'center', width: 130,
          render: (h, params) => {
            const m = { 1: '正常', 2: '黑名单', 3: '白名单' };
            const c = { 1: 'default', 2: 'error', 3: 'success' };
            return h('Tag', { props: { color: c[params.row.type] || 'default' } }, m[params.row.type] || '未知');
          }},
        { title: '访问次数', key: 'access_count', align: 'center', width: 100 },
        { title: '创建时间', key: 'create_time', align: 'center', minWidth: 150, tooltip: true }
      ];
    }
  },
  methods: {
    initDateRange() {
      const today = new Date();
      const y = today.getFullYear();
      const m = String(today.getMonth() + 1).padStart(2, '0');
      const d = String(today.getDate()).padStart(2, '0');
      const endStr = `${y}-${m}-${d}`;
      const sevenDaysAgo = new Date(today);
      sevenDaysAgo.setDate(today.getDate() - 6);
      const sy = sevenDaysAgo.getFullYear();
      const sm = String(sevenDaysAgo.getMonth() + 1).padStart(2, '0');
      const sd = String(sevenDaysAgo.getDate()).padStart(2, '0');
      const startStr = `${sy}-${sm}-${sd}`;
      this.dateRange = [startStr, endStr];
      this.startDate = startStr;
      this.endDate = endStr;
    },
    handleDateChange(date) {
      if (date && date.length === 2) {
        this.startDate = date[0];
        this.endDate = date[1];
      } else {
        this.startDate = '';
        this.endDate = '';
      }
    },
    getStats() {
      this.spinShow = true;
      getSecurityOverview({ start_date: this.startDate, end_date: this.endDate }).then(res => {
        if (res.data.code === 0) this.statsData = res.data.data || {};
        else this.$Message.error(`${res.data.msg}`);
        this.spinShow = false;
      }).catch(() => { this.spinShow = false; });
    },
    getTrend() {
      this.chartSpinShow = true;
      getSecurityOverview({ type: 'trend', start_date: this.startDate, end_date: this.endDate }).then(res => {
        if (res.data.code === 0) {
          const d = res.data.data;
          this.renderChart(d.dates || [], d.access || [], d.abnormal || []);
        } else this.$Message.error(`${res.data.msg}`);
        this.chartSpinShow = false;
      }).catch(() => { this.chartSpinShow = false; });
    },
    renderChart(dates, accessVals, abnormalVals) {
      if (!this.trendChart) this.trendChart = echarts.init(this.$refs.trendChart);
      this.trendChart.setOption({
        tooltip: { trigger: 'axis' },
        legend: { data: ['访问量', '异常量'], bottom: 0 },
        grid: { left: '3%', right: '4%', bottom: '12%', top: '10%', containLabel: true },
        xAxis: { type: 'category', boundaryGap: false, data: dates },
        yAxis: { type: 'value', minInterval: 1 },
        series: [
          { name: '访问量', type: 'line', smooth: true, data: accessVals, itemStyle: { color: '#2d8cf0' }, areaStyle: { color: 'rgba(45,140,240,0.1)' } },
          { name: '异常量', type: 'line', smooth: true, data: abnormalVals, itemStyle: { color: '#ed4014' }, areaStyle: { color: 'rgba(237,64,20,0.1)' } }
        ]
      }, true);
    },
    getTableData() {
      this.tableSpinShow = true;
      const type = this.activeTab === 'access' ? 'access_records' : 'abnormal';
      const params = { type, page: this.pageNum, limit: this.pageSize, start_date: this.startDate, end_date: this.endDate, key: this.searchVal };
      if (this.pathKey) params.path_key = this.pathKey;
      getSecurityOverview(params).then(res => {
        if (res.data.code === 0) { this.pageTotal = res.data.count; this.tableData = res.data.data; }
        else this.$Message.error(`${res.data.msg}`);
        this.tableSpinShow = false;
      }).catch(() => { this.tableSpinShow = false; });
    },
    loadAll() { this.getStats(); this.getTrend(); this.getTableData(); },
    handleTabChange(name) { this.activeTab = name; this.pageNum = 1; this.searchVal = ''; this.pathKey = ''; this.getTableData(); },
    searchinput() { this.pageNum = 1; this.getTableData(); this.getStats(); this.getTrend(); },
    changePage(value) { this.pageNum = value; this.getTableData(); },
    handlePageSize(value) { this.pageSize = value; this.pageNum = 1; this.getTableData(); },

    // --- Card Detail Modal ---
    openCardDetail(type) {
      const titles = {
        visits: '访问记录详情',
        abnormal: '异常访问详情',
        ips: 'IP访问统计',
        blacklist: '黑名单IP列表',
        whitelist: '白名单IP列表',
        wechat: '微信访问记录'
      };
      this.cardModalVisible = true;
      this.cardModalTitle = titles[type] || '详情';
      this.cardDetailType = type;
      this.cardPageNum = 1;
      this.cardSpinShow = true;

      if (type === 'visits') {
        getSecurityOverview({ type: 'access_records', page: 1, limit: this.cardPageSize, start_date: this.startDate, end_date: this.endDate }).then(res => {
          if (res.data.code === 0) { this.cardTableData = res.data.data; this.cardPageTotal = res.data.count; }
          this.cardSpinShow = false;
        }).catch(() => { this.cardSpinShow = false; });
      } else if (type === 'abnormal') {
        getSecurityOverview({ type: 'abnormal', page: 1, limit: this.cardPageSize, start_date: this.startDate, end_date: this.endDate }).then(res => {
          if (res.data.code === 0) { this.cardTableData = res.data.data; this.cardPageTotal = res.data.count; }
          this.cardSpinShow = false;
        }).catch(() => { this.cardSpinShow = false; });
      } else if (type === 'ips') {
        getSecurityOverview({ type: 'ip_stats', start_date: this.startDate, end_date: this.endDate }).then(res => {
          if (res.data.code === 0) { this.cardTableData = res.data.data; this.cardPageTotal = 0; }
          this.cardSpinShow = false;
        }).catch(() => { this.cardSpinShow = false; });
      } else if (type === 'blacklist') {
        getSecurityOverview({ type: 'ip_list', ip_type: 2 }).then(res => {
          if (res.data.code === 0) { this.cardTableData = res.data.data; this.cardPageTotal = 0; }
          this.cardSpinShow = false;
        }).catch(() => { this.cardSpinShow = false; });
      } else if (type === 'whitelist') {
        getSecurityOverview({ type: 'ip_list', ip_type: 3 }).then(res => {
          if (res.data.code === 0) { this.cardTableData = res.data.data; this.cardPageTotal = 0; }
          this.cardSpinShow = false;
        }).catch(() => { this.cardSpinShow = false; });
      } else if (type === 'wechat') {
        getSecurityOverview({ type: 'access_records', page: 1, limit: this.cardPageSize, start_date: this.startDate, end_date: this.endDate, wechat: '1' }).then(res => {
          if (res.data.code === 0) { this.cardTableData = res.data.data; this.cardPageTotal = res.data.count; }
          this.cardSpinShow = false;
        }).catch(() => { this.cardSpinShow = false; });
      }
    },
    changeCardPage(value) {
      this.cardPageNum = value;
      this.cardSpinShow = true;
      if (this.cardDetailType === 'visits') {
        getSecurityOverview({ type: 'access_records', page: value, limit: this.cardPageSize, start_date: this.startDate, end_date: this.endDate }).then(res => {
          if (res.data.code === 0) this.cardTableData = res.data.data;
          this.cardSpinShow = false;
        }).catch(() => { this.cardSpinShow = false; });
      } else if (this.cardDetailType === 'abnormal') {
        getSecurityOverview({ type: 'abnormal', page: value, limit: this.cardPageSize, start_date: this.startDate, end_date: this.endDate }).then(res => {
          if (res.data.code === 0) this.cardTableData = res.data.data;
          this.cardSpinShow = false;
        }).catch(() => { this.cardSpinShow = false; });
      } else if (this.cardDetailType === 'wechat') {
        getSecurityOverview({ type: 'access_records', page: value, limit: this.cardPageSize, start_date: this.startDate, end_date: this.endDate, wechat: '1' }).then(res => {
          if (res.data.code === 0) this.cardTableData = res.data.data;
          this.cardSpinShow = false;
        }).catch(() => { this.cardSpinShow = false; });
      }
    },
    handleCardPageSize(value) {
      this.cardPageSize = value;
      this.cardPageNum = 1;
      this.changeCardPage(1);
    },

    // --- Config Modal ---
    openConfigModal() {
      this.configModalVisible = true; this.configSpinShow = true; this.configSubmitting = false;
      getSecurityConfigList(1, 100, '').then(res => {
        if (res.data.code === 0) {
          this.configList = res.data.data || [];
          const formObj = {};
          this.configList.forEach(item => { formObj['val_' + item.id] = item.config_value || ''; });
          this.configForm = formObj;
        } else this.$Message.error(`${res.data.msg}`);
        this.configSpinShow = false;
      }).catch(() => { this.configSpinShow = false; });
    },
    handleConfigSubmit() {
      this.configSubmitting = true;
      const promises = this.configList.map(item => {
        return operationSecurityConfig({ id: item.id, config_key: item.config_key, config_value: this.configForm['val_' + item.id] || '' }, 'put');
      });
      Promise.all(promises).then(results => {
        const allOk = results.every(r => r.data.code === 0);
        if (allOk) { this.$Message.success('安全配置保存成功'); this.configModalVisible = false; }
        else { const failed = results.find(r => r.data.code !== 0); this.$Message.error(failed ? failed.data.msg : '部分配置保存失败'); }
        this.configSubmitting = false;
      }).catch(() => { this.$Message.error('保存失败'); this.configSubmitting = false; });
    }
  },
  mounted() {
    this.initDateRange();
    this.$nextTick(() => { this.loadAll(); });
  },
  beforeDestroy() {
    if (this.trendChart) { this.trendChart.dispose(); this.trendChart = null; }
  }
}
</script>
<style lang="less" scoped>
.search-con {
  padding: 10px 0;
  .search {
    &-col { display: inline-block; width: 200px; }
    &-input { display: inline-block; width: 200px; margin-left: 2px; }
    &-btn { margin-left: 2px; }
  }
}
.stat-card {
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  }
}
</style>